import { Translator } from '@/types/translator.type';

export const WEEKDAYS: Array<
  'Lundi' | 'Mardi' | 'Mercredi' | 'Jeudi' | 'Vendredi' | 'Samedi' | 'Dimanche'
> = ['Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi', 'Dimanche'];

export const WEEKDAYS_TRANSLATED = (
  t: Translator,
): Record<(typeof WEEKDAYS)[number], string> => ({
  Lundi: t('common.weekdays.lundi'),
  Mardi: t('common.weekdays.mardi'),
  Mercredi: t('common.weekdays.mercredi'),
  Jeudi: t('common.weekdays.jeudi'),
  Vendredi: t('common.weekdays.vendredi'),
  Samedi: t('common.weekdays.samedi'),
  Dimanche: t('common.weekdays.dimanche'),
});
